export interface ReduxDevtoolsWaitOptions {
  isProduction: boolean;
  maxWaitMs?: number;
  intervalMs?: number;
}

/**
 * On a restored session the router can create the first `withDevtools()` store (and thus
 * @angular-architects/ngrx-toolkit's DevtoolsSyncer singleton) before the Redux DevTools browser
 * extension has finished injecting `window.__REDUX_DEVTOOLS_EXTENSION__`. DevtoolsSyncer reads
 * that global exactly once, synchronously, at construction — a miss there permanently falls back
 * to a no-op connection for the rest of the session. Bounding app init on this check (dev builds
 * only) avoids that race without needing to patch the library itself.
 */
export function waitForReduxDevtoolsExtension(options: ReduxDevtoolsWaitOptions): Promise<void> {
  const { isProduction, maxWaitMs = 1000, intervalMs = 25 } = options;
  if (isProduction || window.__REDUX_DEVTOOLS_EXTENSION__) return Promise.resolve();

  return new Promise(resolve => {
    const start = Date.now();
    const timer = setInterval(() => {
      if (window.__REDUX_DEVTOOLS_EXTENSION__ || Date.now() - start >= maxWaitMs) {
        clearInterval(timer);
        resolve();
      }
    }, intervalMs);
  });
}
